module.exports = __webpack_public_path__ + "media/images/lp_chintai/sec06_ico_01-7d20c24b5ef4daa84d1de0570c20ceb8.png";